import * as React from 'react';

import { localeData } from '../../locales/data';
import { addModifiers } from '../../shared/helpers';

import './Messages.scss';
import { FormattedMessageHelper } from '../../shared/helpers/internationalization';

interface MessagesMenuProps {
  typeAggregate: 'unread' | 'all';
  handleChangeAggregation: (item: string) => void;
  handleMarkAsReadAll: () => void;
}

export const Title = () => (
  <div className="messages__menu-title">
    <h2>
      <FormattedMessageHelper tagName="span" id="messages.title" defaultMessage={localeData.en['messages.title']} />
    </h2>
  </div>
);

export const OptionsComponent = ({ handleMarkAsReadAll }: MessagesMenuProps) => (
  <div className="btn-green menu-top__link-btn" onClick={handleMarkAsReadAll}>
    <FormattedMessageHelper tagName="span" id="messages.all.read" defaultMessage={localeData.en['messages.all.read']} />
  </div>
);

export const FooterComponent = ({ typeAggregate, handleChangeAggregation }: MessagesMenuProps) => {
  const handlerUnread = () => handleChangeAggregation('unread');
  const handlerAll = () => handleChangeAggregation('all');

  return (
    <div className="messages__menu-footer">
      <button className={addModifiers('menu-bottom__filter-button', typeAggregate === 'unread' ? ['active'] : [])} onClick={handlerUnread}>
        Unread
      </button>
      <button className={addModifiers('menu-bottom__filter-button', typeAggregate === 'all' ? ['active'] : [])} onClick={handlerAll}>
        All
      </button>
    </div>
  );
};
